import {NoteIcon, PencilIcon, PlusIcon, TrashIcon, UploadIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Box, Button, IconButton, VisuallyHidden} from '@primer/react'
import {DataTable} from '@primer/react/experimental'
import type {ModelState} from '../../../types'
import {GiveFeedback} from '../../playground/components/GettingStartedDialog/GiveFeedback'
import styles from './Evals.module.css'
import {Header} from './Header'

export type EvalsProps = {
  modelState: ModelState
  canUseO1Models: boolean
}

type DataRow = {
  id: string
  data: {[variable: string]: string}
  completion?: string
}

export function Evals({modelState, canUseO1Models}: EvalsProps) {
  const {gettingStarted, modelInputSchema, catalogData} = modelState
  const rows: DataRow[] = []

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100dvh - 64px)',
        flex: 1,
      }}
    >
      <Box
        sx={{
          display: ['block', 'block', 'none'],
        }}
      >
        <GiveFeedback mobile />
      </Box>
      <Box sx={{height: '100%', width: '100%', p: 3, overflow: 'auto'}}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            width: '100%',
            height: '100%',
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              maxHeight: '100%',
              height: '100%',
            }}
          >
            <Header
              run={() => {}}
              running={false}
              model={catalogData}
              modelInputSchema={modelInputSchema}
              canUseO1Models={canUseO1Models}
              gettingStarted={gettingStarted}
            />
            <div className={`flex-1 d-flex flex-column border overflow-hidden rounded-2`}>
              <div className="d-flex flex-justify-between position-sticky top-0 p-2 border-bottom bgColor-muted flex-items-center">
                <>
                  <Button
                    size="small"
                    leadingVisual={UploadIcon}
                    onClick={e => {
                      e.preventDefault()
                    }}
                  >
                    Import rows
                  </Button>
                </>
                <Button sx={{ml: 2}} size="small" leadingVisual={PlusIcon}>
                  Add row
                </Button>
                <div className="flex-1" />
                <ActionMenu>
                  <ActionMenu.Button size="small">Add evaluator</ActionMenu.Button>
                  <ActionMenu.Overlay width="medium">
                    <ActionList>
                      {/* <ActionList.GroupHeading>Simple</ActionList.GroupHeading> */}
                      <ActionList.Item onSelect={() => {}}>
                        <ActionList.LeadingVisual>
                          <NoteIcon />
                        </ActionList.LeadingVisual>
                        String check
                        <ActionList.Description variant="block">
                          Check if the output contains specific strings
                        </ActionList.Description>
                      </ActionList.Item>
                      {/* <ActionList.GroupHeading>LLM</ActionList.GroupHeading> */}
                      <ActionList.Item onSelect={() => {}}>
                        <ActionList.LeadingVisual>
                          <PencilIcon />
                        </ActionList.LeadingVisual>
                        Custom prompt
                        <ActionList.Description variant="block">
                          Create an evaluator by writing your own prompt
                        </ActionList.Description>
                      </ActionList.Item>
                    </ActionList>
                  </ActionMenu.Overlay>
                </ActionMenu>
              </div>

              <div className={styles['eval-grid']}>
                <DataTable
                  columns={[
                    // Dataset columns, TODO: use actual dataset
                    {
                      id: 'input',
                      renderCell: row => <>{row.data.input}</>,
                      header: 'input',
                    },
                    {
                      id: 'expected',
                      renderCell: row => <>{row.data.expected}</>,
                      header: 'expected',
                    },
                    // Hard-coded output column
                    {
                      id: 'output',
                      header: 'Output',
                      renderCell: row => <>{row.completion || null}</>,
                    },
                    // Evaluators
                    //...evalsState.evaluators.map(evaluatorToColumn),
                    // Actions
                    {
                      id: 'action',
                      header: () => <VisuallyHidden>Actions</VisuallyHidden>,
                      renderCell: _row => {
                        return (
                          <>
                            <IconButton
                              aria-label={`Edit`}
                              icon={PencilIcon}
                              variant="invisible"
                              onClick={() => {
                                // handleEdit(row.data)
                              }}
                            />
                            <IconButton
                              aria-label={`Delete`}
                              icon={TrashIcon}
                              variant="invisible"
                              onClick={() => {
                                // manager.evalsRemoveRow(row.id)
                              }}
                            />
                          </>
                        )
                      },
                    },
                  ]}
                  data={rows}
                />
              </div>
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

try{ Evals.displayName ||= 'Evals' } catch {}